import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import tool from './js/tool'
import store from './store/store.js'
import { Message } from 'element-ui';

axios.defaults.baseURL = 'https://express.baolong-shop.com';

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$tool = tool

Vue.use(ElementUI);

var code = ''
document.onkeypress = function (event) {
  if (event.which == 13) {
    var list = store.getters.scanList
    code = code + ''
    let isIn = false
    for (var i = 0; i < list.length; i++) {
      let str = list[i]
      if (str == code) {
        isIn = true
        break
      }
    }
    if (!isIn) {
      list.push(code)
      store.dispatch('setScanList', list)
    }
    else Message({
      showClose: true,
      message: '请不要重复扫发货单',
      type: 'warning'
    });

    code = ''
  }
  else {
    code += event.key;
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js